import { z } from 'zod';
/** One Google Play listing placement tested by an Experiment. */
export const AssetTypeSchema = z.enum(['appIcon', 'featureGraphic', 'screenshotSet', 'previewVideo']);
/** The market and locale context for an Experiment, or Global when none is intended. */
export const TargetSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('global') }),
    z.object({ kind: z.literal('market'), market: z.string().min(2), locale: z.string().min(2) }),
]);
export const GLOBAL_TARGET = { kind: 'global' };
/** The lightweight lifecycle position of an Experiment. */
export const ExperimentStateSchema = z.enum(['exploring', 'exported', 'live', 'closed']);
/** The Google Play device slot a screenshot set is validated against. */
export const DeviceSlotSchema = z.enum([
    'phone',
    'sevenInchTablet',
    'tenInchTablet',
    'chromebook',
    'androidTv',
    'wearOs',
    'xr',
]);
/** Everything a Technical Check needs to judge a screenshot Candidate. */
export const ScreenshotValidationContextSchema = z.object({
    deviceSlot: DeviceSlotSchema,
    target: TargetSchema,
});
/** The Outcome recorded for an Experiment, when the operator records one. */
export const OutcomeVerdictSchema = z.enum(['candidateWon', 'controlWon', 'noClearWinner', 'notCompleted']);
//# sourceMappingURL=domain.js.map